// Whitelist adapter: the shared viewer receives only authorized timesheet facts.
function reviewSources(grid, key) {
    const group = grid.groups.find(g => g.rows.some(row => row.key === key));
    if (!group) return null;
    const sourceMap = new Map(grid.sources.map(s => [s.timesheet_id, s]));
    const rows = group.rows.map((row, index) => {
        const source = sourceMap.get(row.source_id), codes = [], codeIds = new Map();
        function codeId(code) {
            if (!code) return null;
            if (!codeIds.has(code)) { const id = codes.length + 1; codeIds.set(code, id); codes.push({id, code, name: ((grid.codes || []).find(c => c.code === code) || {}).name || code}); }
            return codeIds.get(code);
        }
        return {historical: Boolean(row.historical), id: String(index + 1), key: row.key, available: true, employee_id: group.employee_id,
            employee_name_snapshot: row.name || group.name, building_id: source.building_id, object_name: source.object_name,
            timesheet_id: source.timesheet_id, line_id: row.line_id, revision_id: source.revision_id || 0,
            timesheet_name: source.name, day_counting: {full_day_minimum_minutes: row.day_counting && row.day_counting.full_day_minimum_minutes,
                partial_day_value: row.day_counting && row.day_counting.partial_day_value}, codes,
            entries: Object.entries(row.days).map(([work_date, day]) => ({work_date, worked_minutes: day.worked_minutes,
                absence_code_id: codeId(day.absence_code), travel_code_id: codeId(day.travel_code),
                other_code_id: codeId(day.other_code || (/^дт$/i.test(String(day.source_value || '')) ? day.source_value : null)),
                source_value: row.historical ? day.source_value : null, travel_contributes: false}))};
    });
    const selected = rows.find(row => row.key === key);
    const parts = rows.map(row => ({timesheet_id: row.timesheet_id, line_id: row.line_id, revision_id: row.revision_id, building_id: row.building_id, object_name: row.object_name}));
    return {rows, parts, name: selected.employee_name_snapshot, buildingId: selected.building_id, historical: Boolean(grid.historical)};
}
module.exports = {reviewSources};
